<template>
  <div class="traffic-count">
    <tc-select-modal :map="mapgl" :controller="BaseController" v-if="!mode" />
    <div class="traffic-count-layout">
      <div class="traffic-count-upper">
        <r-main-panel
          v-if="mode === 'edit'"
          title="Создание / редактирование"
          icon="edit"
        >
          <tc-editor
            :map="mapgl"
            :state="editorState"
            :draw="draw"
            :controller="EditorController"
            @open-gcp-card="openGcpCard"
          />
        </r-main-panel>
        <div id="traffic-count-map" class="traffic-count-map">
          <div class="traffic-count-controls" v-if="mode">
            <el-button class="r-button" type="info" @click="backToModeSelect">
              <i class="el-icon-arrow-left" />
              К списку инструментов
            </el-button>
          </div>

          <gcp-list
            v-if="mode === 'fill' && !!FillController"
            :state="editorState"
            :fill-controller="FillController"
          />

          <div class="traffic-count-map-actions">
            <map-tools
              :map="mapgl"
              :is-traffic-counts="true"
              :baselayer-id="5"
              @change-prop="changeProp"
              :map-bearing="mapBearing"
              :is3d="is3d"
            />
            <traffic-counts-legend
              v-if="mode === 'fill'"
              :baselayer-id="5"
              :is-legend-active="isLegendActive"
              @toggle-legend="toggleLegend"
            />
          </div>
        </div>
      </div>
      <r-bottom-panel v-if="mode === 'fill' && activeCp">
        <cp-card :state="editorState" :controller="FillController" />
      </r-bottom-panel>
    </div>
    <gcp-settings
      v-if="gcpSettingsVisible"
      :visible="gcpSettingsVisible"
      :state="editorState"
      :mapgl="mapgl"
      :draw="draw"
      @close="toggleGcpSettings(false)"
    />
  </div>
</template>

<script>
import cloneDeep from "lodash.clonedeep";
import MapTools from "../map/components/map-tools/map-tools";
import TcSelectModal from "./components/tc-select-modal";
import TcEditor from "./components/editor-mode/tc-editor";
import TrafficCountsLegend from "./components/tc-legend";
import GcpSettings from "./components/editor-mode/gcp-settings";
import GcpList from "./components/gcp-list/gcp-list";
import CpCard from "./components/fill-mode/cp-card";
import { initMap } from "./core";
import { initialEditorState, initialFillState } from "./configs";

export default {
  components: {
    MapTools,
    TcSelectModal,
    TrafficCountsLegend,
    TcEditor,
    GcpSettings,
    GcpList,
    CpCard
  },
  data() {
    return {
      mapgl: null,
      draw: null,
      mapLoading: false,
      mapBearing: 0,
      is3d: false,
      EditorController: null,
      FillController: null,
      BaseController: null,
      isLegendActive: true,
      editorState: cloneDeep(initialEditorState),
      fillState: cloneDeep(initialFillState),
      gcpSettingsVisible: false
    };
  },
  watch: {
    "$store.state.trafficCount.mode": function(mode) {
      this.$nextTick(() => this.mapgl.resize());

      switch (mode) {
        case "edit":
          this.EditorController.toggleOn();
          break;
        case "fill":
          this.FillController.toggleOn();
          break;
      }
    },
    "$store.state.trafficCount.fill.activeCp": function() {
      setTimeout(() => this.mapgl.resize(), 100);
    },
    "$store.state.theme": function(val, prev) {
      this.mapgl.setLayoutProperty(prev, "visibility", "none");
      this.mapgl.setLayoutProperty(val, "visibility", "visible");
    }
  },
  computed: {
    mode() {
      return this.$store.state.trafficCount.mode;
    },
    model() {
      return this.$store.state.trafficCount.model;
    },
    activeCp() {
      return this.$store.state.trafficCount.fill.activeCp;
    }
  },
  methods: {
    saveMapParams() {
      const zoom = this.mapgl.getZoom();
      const center = this.mapgl.getCenter();

      localStorage.setItem("tcMapCenter", JSON.stringify(center));
      localStorage.setItem("tcMapZoom", JSON.stringify(zoom));
    },
    changeProp({ field, value }) {
      this[field] = value;
    },
    toggleLegend() {
      this.isLegendActive = !this.isLegendActive;
    },
    toggleGcpSettings(value) {
      this.gcpSettingsVisible = value;
    },
    openGcpCard() {
      this.toggleGcpSettings(true);
    },
    getObjectsLimit() {
      return 10000;
    },
    backToModeSelect() {
      switch (this.mode) {
        case "edit":
          this.EditorController.toggleOff();
          break;
        case "fill":
          this.FillController.toggleOff();
          break;
      }

      this.$store.commit("SET_TC_STATE_PROP", {
        name: "mode",
        value: null
      });
    }
  },
  mounted() {
    initMap(this);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.saveMapParams);
    this.$store.commit("CLEAR_TC_MODEL");
    this.$store.commit("CLEAR_TC_FILL");
    this.$store.commit("SET_TC_STATE_PROP", { name: "mode", value: null });
    this.$store.commit("SET_TC_STATE_PROP", {
      name: "view",
      value: "model-list"
    });
    this.saveMapParams();
  }
};
</script>

<style lang="scss">
.traffic-count {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: row;
  background-color: var(--bg_surface) !important;

  &-layout {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  &-upper {
    height: 100%;
    display: flex;
  }

  &-map {
    height: 100%;
    width: 100%;
  }

  &-controls {
    position: absolute;
    left: 50%;
    top: 16px;
    z-index: 100;
    transform: translateX(-50%);
  }

  &-map-actions {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 100;
  }

  // toggle off mapbox focus and controls
  .mapboxgl-canvas {
    &:focus {
      outline: none;
    }
  }
  .mapboxgl-ctrl-top-right {
    display: none;
  }
}
</style>
